<template>
  <v-simple-table dense>
    <template v-slot:default>
      <thead>
        <tr>
          <th colspan="4" class="py-2">Informazioni sulle merci trasportate</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in innerValue" :key="index" style="height: 80px">
          <td class="font-weight-medium" width="190px">{{ getLabel(index) }}</td>
          <template v-if="item">
            <td class="">
              <div class="font-weight-medium">
                {{ getGoodsTypeDesc(item.type) }}
                <v-btn @click="$emit('click:edit', index)" depressed x-small icon class="mt-n1">
                  <v-icon right>mdi-pencil</v-icon>
                </v-btn>
              </div>
              <div class="text--secondary">{{ getAspectTypeDesc(item.aspect) }}</div>
            </td>
            <td width="110px" class="text-right px-1">
              <v-text-field
                v-model.number="item.weight"
                type="number"
                outlined
                class="rounded-lg ml-auto mb-n5 hide-arrows text-right"
                hide-spin-buttons
                :min="1"
                dense
                style="width: 120px"
                :rules="weightRules"
                @input="handleChanges"
                suffix=",00"
                persistent-hint
                hint="in quintali"
                @keypress="isNumber($event)"
              >
                <template #append-outer>
                  <div class="mt-1 text-no-wrap"><i>q</i></div>
                </template>
              </v-text-field>
            </td>
            <td width="60px" class="text-right px-0 pr-2">
              <v-btn icon @click="$emit('click:delete', index)">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </td>
          </template>
          <template v-else>
            <td>
              <v-btn text @click="$emit('click:add', index)">
                <v-icon left color="success">mdi-plus-circle</v-icon> Aggiungi
              </v-btn>
              <div class="text--secondary" v-if="getAddGoodsHelpMessage(index)">
                {{ getAddGoodsHelpMessage(index) }}
              </div>
            </td>
            <td></td>
            <td></td>
          </template>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
// Validations
import { min, max } from '@/validations'

// Types
import { goodsTypes, cargoTypes, Helper as _ } from '@/types'

export default {
  name: 'JourneyFormGoodsTable',
  props: {
    value: {
      type: [Object, Array],
      default: () => [null, null],
    },
    labels: {
      type: Array,
      default: () => ['1', '2'],
    },
    messages: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      innerValue: null,
      weightRules: [min(1), max(440)],
    }
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler: function (val) {
        this._setInnerValue(val)
      },
    },
  },
  created() {
    this._setInnerValue(this.value)
  },

  computed: {},
  methods: {
    _setInnerValue(value) {
      const [g0, g1] = value

      this.innerValue = [g0, g1]
    },
    getLabel(index) {
      return this.labels?.[index] ?? ''
    },
    getGoodsTypeDesc(type) {
      return _(goodsTypes).getDescById(type)
    },
    getAspectTypeDesc(type) {
      return _(cargoTypes).getDescById(type)
    },
    handleChanges() {
      this.$emit('input', [...this.innerValue])
    },
    removeGoods(index) {
      this.innerValue[index] = null
    },
    getAddGoodsHelpMessage(index) {
      return this.messages?.[index] ?? ''
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault()
      } else {
        return true
      }
    },
  },
}
</script>

<style lang="scss" scoped>
table > tbody > tr > td {
  padding-top: 0rem !important;
}

::v-deep .hide-arrows {
  input[type='number'] {
    text-align: right;
    font-weight: bold;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }
}
</style>
